import { DataBean } from "../DataBean";

export class ProductPhoto extends DataBean {


    public async getProductPhotoCatalog(idProduct: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductPhotoCatalog_Number", [idProduct]);
    }

    public async deleteProductPhoto(idProductPhoto: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteProductPhoto_Number", [idProductPhoto]);
    }

}